export const reportsStoreFeatureName = 'reports';
